export const SUBJECT_SETTING = {
  WORKSPACE: 'workspace',
  USER: 'user',
  PROJECT: 'project',
};

export const ITEM_PER_PAGE_DEFAULT = 20;

export const TOTAL_VISIBLE = 10;
